export default __webpack_public_path__ + "static/media/4.c7a59c3a.jpg";